import { useEffect, useState } from "react";
import { Wifi, WifiOff, RefreshCw, CheckCircle2 } from "lucide-react";
import { subscribeQueue, replayQueue } from "../lib/offline";
import api from "../lib/api";

export default function NetworkStatus() {
  const [online, setOnline] = useState(navigator.onLine);
  const [pending, setPending] = useState(0);
  const [syncing, setSyncing] = useState(false);
  const [justSynced, setJustSynced] = useState(false);

  useEffect(() => {
    const onUp = () => setOnline(true);
    const onDown = () => setOnline(false);
    window.addEventListener("online", onUp);
    window.addEventListener("offline", onDown);
    const unsub = subscribeQueue((q) => setPending(q.length));
    return () => {
      window.removeEventListener("online", onUp);
      window.removeEventListener("offline", onDown);
      unsub();
    };
  }, []);

  const sync = async () => {
    setSyncing(true);
    const r = await replayQueue(api);
    setSyncing(false);
    if (r.synced > 0) {
      setJustSynced(true);
      setTimeout(() => setJustSynced(false), 3000);
    }
  };

  if (online && pending === 0 && !justSynced) {
    return (
      <div className="flex items-center gap-1.5 px-2 py-1 text-[10px] font-data uppercase tracking-wider text-[var(--primary-dark)]" data-testid="net-status-online">
        <Wifi size={11}/> En ligne
      </div>
    );
  }

  if (!online) {
    return (
      <div className="flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-medium bg-[var(--alert-soft)] text-[#B91C1C] border border-[#FCA5A5]" data-testid="net-status-offline">
        <WifiOff size={12}/> Hors ligne
        {pending > 0 && <span className="font-data">· {pending} en attente</span>}
      </div>
    );
  }

  if (pending > 0) {
    return (
      <button onClick={sync} disabled={syncing} className="flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-medium bg-[var(--warn-soft)] text-[#B45309] border border-[#FCD34D] hover:bg-[#FDE9C8]" data-testid="net-status-pending">
        <RefreshCw size={12} className={syncing ? "animate-spin" : ""}/> {syncing ? "Synchronisation..." : `Synchroniser (${pending})`}
      </button>
    );
  }

  return (
    <div className="flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-medium bg-[var(--primary-soft)] text-[var(--primary-dark)] border border-[#A7E0BF]" data-testid="net-status-synced">
      <CheckCircle2 size={12}/> Synchronisé
    </div>
  );
}
